/* eslint-disable @typescript-eslint/no-explicit-any */
import SearchIcon from "components/Shared/icons/search";
import { useEffect, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { RichText } from "@sitecore-jss/sitecore-jss-nextjs";
import { DGABreadcrumbs } from "components/Shared/dga-breadcrumbs/DGABreadcrumbs";
import { DGABreadcrumbsItemProps } from "components/Shared/dga-breadcrumbs/helpers/DGABreadcrumbsType";
import { DGAButton, getDgAButtonClassNames } from "components/Shared/dga-button/DGAButton";
import DGAInput from "components/Shared/DGA-inputs/DGA-input";
import React from "react";
import { useRouter } from "next/router";
import sanitizeHref from "lib/UrlSanitization/UrlSanitization";
import Close from "components/Shared/icons/close";
import DGADropdownInput from "components/Shared/DGA-inputs/DGA-dropdown-input";
import { ExternalLinkTypeIcon } from "components/Shared/dga-link/ExternalLinkTypeIcon";
type HeaderProps = {
  Title: { value: string };
  SearchBarPlaceholder?: { value: string };
  search?: string;
  setsearch?: any;
  locale: string;
  isDetailsPage: boolean;
  ServicePageHomeBreadcrumbText: {
    value: string;
  };
  ServicePageHomeBreadcrumbLink: {
    value: {
      href: string;
      text: string;
      anchor: string;
      linktype: string;
      class: string;
      title: string;
      target: string;
      querystring: string;
      id: string;
    };
  };
  ServicePageServiceBreadCurmb?: {
    value: {
      href: string;
      text: string;
      anchor: string;
      linktype: string;
      class: string;
      title: string;
      target: string;
      querystring: string;
      id: string;
    };
  };
  ServicePageServiceBreadCurmbText?: {
    value: string;
  };
  SearchBtnText?: {
    value: string;
  };
  ServiceDescription?: {
    value: string;
  };
  sortItems: SortItem[];
  order: number;
  setOrder:any;
  GoToServiceBtnTitle?: {
    value: string;
  };
  GoToServiceBtnLink?: {
    value: {
      href: string;
      target?: string;
    };
  };
  ManuallyApply?: {
    value: boolean;
  };
  pageId?: string;
  pageName?: string;
  pageUrl?: string;
};

const Header = (props: HeaderProps): JSX.Element => {
  const router = useRouter();
  const [inputValue, setInputValue] = useState(""); // User input
  const [filteredSuggestions, setFilteredSuggestions] = useState<Suggestion[]>([]); // Filtered list
  const [showSuggestions, setShowSuggestions] = useState(false); // Show/Hide dropdown
  const [selectedSuggestion, setSelectedSuggestion] = useState(-1); // Track which suggestion is highlighted
  const [suggestions, setSuggestions] = useState<Suggestion[]>([]);
  const inputRef = React.useRef<any>(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedSortOption, setSelectedSortOption] = useState<any>({
        name: '',
        value: null,
  });

  function changeSortMethod(e:any){
      setSelectedSortOption({name:props?.sortItems[e].fields?.Title?.value, value: props?.sortItems[e]?.id})
      props.setOrder(e);
  }

  function search(query: string) {
    props.setsearch(query);
  }

  const searchClicked = () => {
    search(inputValue || "");
    setFilteredSuggestions([]);
    setShowSuggestions(false);
    setSelectedSuggestion(-1);
  };

  const logGoToServiceClick = () => {
    axios.post(
      `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/Service/Visits/Submit`,
      {
        ServiceId: props?.pageId ?? "",
        ServiceName: props?.pageName ?? "",
        PageUrl: props?.pageUrl ?? router.asPath,
      },
      { headers: { "Content-Type": "application/json" } }
    ).catch(err => console.error(err));
  };

  const findIndex  = (id:string): number => {
        let i:number = -1;
        props?.sortItems.forEach((item:SortItem, index:number) => {
             if( item?.id === id) {
            
              i = index;
            }

         });
         return i;
  }

  useEffect(()=>{
    if (!props?.isDetailsPage) {
      if(props?.order) {
          props?.sortItems.map((item: SortItem, index:number) =>{
            if(item?.fields?.value?.value === props?.order) {
              setSelectedSortOption({name:props?.sortItems[index]?.fields?.Title?.value, value:props?.sortItems[index]?.fields?.value?.value})
            }
          })
      } else {
        setSelectedSortOption({name:props?.sortItems[0]?.fields?.Title?.value, value:props?.sortItems[0]?.fields?.value?.value})

      }

    }
  },[]);

  useEffect(() => {
    if (!props?.isDetailsPage) {
      if(props?.order ) {
        props?.sortItems.map((item: SortItem, index:number) =>{
            if(item?.fields?.value?.value === props?.order) {
              setSelectedSortOption({name:props?.sortItems[index].fields?.Title?.value, value:props?.sortItems[index]?.id})
            }
        })
      } else {
        setSelectedSortOption({name:props?.sortItems[0].fields?.Title?.value, value:props?.sortItems[0]?.id})
    }
  }
  }, [props?.locale]);

  const getSuggestions = async (e: any) => {
    // if the user press enter
    if (e.keyCode === 13) {
      search(e?.target?.value);
      setFilteredSuggestions([]);
      setShowSuggestions(false);
      setSelectedSuggestion(-1);
      // else ....
    } else {
      try {
        const res: AxiosResponse = await axios({
          url: `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/Service/GetServices`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            culture: props?.locale,
            pageSize: 9,
            pageNumber: 0,
            order: 0,
            search: e?.target?.value,
            categoryIds: [],
            sectorIds: [],
          },
        });
        setSuggestions(res?.data?.ServiceData);
        filterSuggestions(e?.target?.value);
      } catch (_error) {
        // Handle error
      }
    }
  };

  const filterSuggestions = (e: string) => {
    setInputValue(e);
    setFilteredSuggestions(suggestions);
    setShowSuggestions(true);
    setSelectedSuggestion(-1);
  };

  const goToServiceDetailsPage = (suggestion: Suggestion) => {
    setInputValue(suggestion?.Title);
    setShowSuggestions(false);
    const locale = props.locale || "en";
    const itemPath = typeof suggestion?.itemPath === "string" ? suggestion.itemPath : "";
    const pathWithEncodedSpaces = itemPath.replace(/ /g, "%20");
    const targetHref = `/${locale}${pathWithEncodedSpaces}`;
    window.location.href = sanitizeHref(targetHref);
  };
  useEffect(() => {
    setInputValue("");
    const searcInput: any = document?.getElementById("searchInput");
    if (searcInput?.value) {
      searcInput.value = "";
    }
  }, [props?.locale]);

  const renderSuggestions = () => {
    if (!showSuggestions || !inputValue) return null;
    if (filteredSuggestions.length === 0) {
      return <div className=" absolute bottom-0 no-suggestions"></div>;
  }
    return (
      <ul
        className={`absolute suggestions w-full top-[110%] ${props?.locale == "en" ? "left-0" : "right-0"}`}
        style={{ borderRadius: "10px" }}
      >
        {filteredSuggestions.map((suggestion, index) => (
          <li
            key={suggestion.Id}
            className={
              index === selectedSuggestion
                ? "w-full highlight text-[#6E7182] text-[18px]  !flex gap-2  items-center "
                : "w-full !flex gap-2   items-center "
            }
            onClick={() => goToServiceDetailsPage(suggestion)}
            style={{ borderTop: "0.5px solid #E7E7E7" }}
          >
            {suggestion?.Title}
            <span className="bg-brand-1600 text-[#6E7182] text-[14px] p-2">
              {suggestion?.Sector}
            </span>
          </li>
        ))}
      </ul>
    );
  };
const restructureUrl=(url:string)=>{  
  if(url){
    if(props?.ServicePageServiceBreadCurmb?.value?.linktype=="internal"){
      // Find /Modules (case-insensitive) and return everything from that point onwards in lowercase
      const lowerUrl = url.toLowerCase();
      const modulesIndex = lowerUrl.indexOf('/modules');
      if(modulesIndex !== -1){
        return url.substring(modulesIndex).toLowerCase();
      }
      return "";
    }else{
      return url;
    }
  }else{
    return "";
  }
}
  const dgaBreadcrumbsLinks: DGABreadcrumbsItemProps[] = !props.isDetailsPage
    ? [
        {
          id: "svs-breadcrumb-home",
          label: props?.ServicePageHomeBreadcrumbText?.value,
          link: {
            href: restructureUrl(props?.ServicePageHomeBreadcrumbLink?.value?.href ?? ""),
            querystring: "",
            linktype: "internal",
            target: props?.ServicePageHomeBreadcrumbLink?.value?.target,
          },
        },
        {
          id: "svs-breadcrumb-svs",
          label: props?.ServicePageServiceBreadCurmbText?.value ?? "",
          link: {
            href: restructureUrl(props?.ServicePageServiceBreadCurmb?.value?.href ?? ""),
            querystring: "",
            linktype: "internal",
            target:
              props?.ServicePageServiceBreadCurmb?.value?.target === "_blank" ? "_blank" : "_self",
          },
        },
      ]
    : [
        {
          id: "svs-breadcrumb-home",
          label: props?.ServicePageHomeBreadcrumbText?.value,
          link: {
            href: restructureUrl(props?.ServicePageHomeBreadcrumbLink?.value?.href ?? ""),
            querystring: "",
            linktype: "internal",
            target: props?.ServicePageHomeBreadcrumbLink?.value?.target,
          },
        },
        {
          id: "svs-breadcrumb-svs",
          label: props?.ServicePageServiceBreadCurmbText?.value ?? "",
          link: {
            href: restructureUrl(props?.ServicePageServiceBreadCurmb?.value?.href ?? ""),
            querystring: "",
            linktype: "internal",
            target:
              props?.ServicePageServiceBreadCurmb?.value?.target === "_blank" ? "_blank" : "_self",
          },
        },
        {
          id: "svs-breadcrumb-current-svs",
          label: props?.Title?.value,
          link: null,
        },
      ];

  return (
    <>
      <div className="service-page-header-section w-ful bg-primary-25  py-10 relative ">
        <div className={`${props?.isDetailsPage ? "" : "responsive"} flex flex-col justify-start gap-4 content-container  h-full`}>
          <DGABreadcrumbs links={dgaBreadcrumbsLinks ?? []} />
          <div className="flex flex-row gap-4 items-start">
            <div className="flex-1 flex flex-col gap-4">
              <h1 className=" text-primary-1000 text-[30px] lg:text-[35px] 2xl:text-[40px] font-bold">
                {props?.Title?.value}
              </h1>
            
            </div>
            {(props?.ManuallyApply?.value !== true && 
              props?.GoToServiceBtnTitle?.value && 
              props?.GoToServiceBtnLink?.value?.href) && (
              <div className="w-fit ">
                <a
                  href={props?.GoToServiceBtnLink?.value?.href}
                  target={props?.GoToServiceBtnLink?.value?.target || "_blank"}
                  rel={
                    (props?.GoToServiceBtnLink?.value?.target || "_blank") === "_blank"
                      ? "noopener noreferrer"
                      : undefined
                  }
                  onClick={(_) => {
                    logGoToServiceClick();
                  }}
                  className={getDgAButtonClassNames(
                    "primary",
                    "lg",
                    "inline-flex items-center gap-2"
                  )}
                >
                  <span className="flex items-center gap-2">
                    <span>{props?.GoToServiceBtnTitle?.value}</span>
                    <ExternalLinkTypeIcon />
                  </span>
                </a>
              </div>
            )}
          </div>
          {props?.ServiceDescription?.value && (
                <div className="text-[16px] text-primary-1000 w-full  text-start">
                  <RichText field={props?.ServiceDescription} />
                </div>
              )}
          {!props?.isDetailsPage && (
            <div className=" gap-2 flex">
              {/* <div className="hidden md:block md:col-span-3"></div> */}
              <div className="w-full  flex md:flex-row flex-col gap-2 ">
                  <div className=' md:w-fit w-full relative block'>
                      <DGADropdownInput
                        value={selectedSortOption.value ||props?.sortItems[0].id}
                        options={props?.sortItems.map((item) => ({ value: item.id, label: item.fields?.Title?.value }))}
                        maxHeight={300}
                        closeAfterSelect
                        onChange={(selected) => {
                          let i = findIndex(selected as string) ;
                        changeSortMethod(i);
                        }}
                        name={selectedSortOption}
                        variant='default'
                        placeholder=''
                        InputSize="lg"
                      />
                  </div>
                  <div className="search-input autocomplete w-full md:w-[calc(100%-120px)]  items-center ">
                    <DGAInput
                      type="text"
                      name="searchInput"
                      ref={inputRef}
                      placeholder={props?.SearchBarPlaceholder?.value}
                      InputSize="lg"
                      onKeyUp={async (e: any) => {
                        getSuggestions(e);
                        setSearchValue(e.target.value);
                      }}
                      containerClassName="!bg-white"
                      startIcon={
                        <button
                          type="submit"
                          aria-label={props?.SearchBtnText?.value || "Search"}
                          className="disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                          <SearchIcon color={"#161616"} classes="w-5 h-5 cursor-pointer" aria-hidden />
                        </button>
                      }
                      endIcon={
                        <button
                          type="button"
                          aria-label="Clear search"
                          onClick={async () => {
                            setSearchValue("");
                            setFilteredSuggestions([]);
                            setShowSuggestions(false);
                            setSelectedSuggestion(-1);
                            if (inputRef.current) {
                              inputRef.current.value = "";
                              inputRef.current.focus();
                              // Trigger input event to update any React state
                              const event = new Event("input", { bubbles: true });
                              inputRef.current.dispatchEvent(event);
                            }
                          }}
                        >
                          {searchValue && <Close aria-label="" aria-hidden={true} />}
                        </button>
                      }
                    />
                    {renderSuggestions()}
                  </div>
                  <div className="search-btn md:self-auto self-end ">
                    <DGAButton
                      type="submit"
                      buttonContent={props?.SearchBtnText?.value}
                      onClick={() => searchClicked()}
                      size="lg"
                      variant="primary"
                      className="!ring-0 !ring-offset-0"
                    />
                  </div>
              </div>

            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default Header;

type Suggestion = {
  Id: string;
  Title: string;
  Description: string;
  Sector: string;
  SectorId: string;
  Visits: number;
  itemPath:string;
};

type SortItem = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
      Title: {
          value: string;
      },
      value: {
          value: number;
      }
  }
}
